<ion-content class="ion-no-padding">
  <div class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue"><span *ngIf="!editContactId">Add</span><span
            *ngIf="editContactId">Edit</span> Contact</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">

          <ion-button class="filled-blue-btn" (click)="onSubmit(true)" *ngIf="!editContactId">
            Save & New
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="onSubmit(false)">
            Save
          </ion-button>
          <ion-button (click)="closeModal()" class="unfilled-gray-btn">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line"></div>

      <!-- lead-details form -->
      <div class="d-flex justify-content-start ion-padding-horizontal py-1 bg-light-gray">
        <ion-title class="dark-title-sm ion-no-padding" style="flex: 0;">{{relatedTo}} Details</ion-title>
        <div class="input-container d-flex ms-3 align-items-center">
          <label for="Related To" class="label">Related to</label>
          <div>
            <select name="" id="" class="input ms-2 py-1" [(ngModel)]="relatedTo" [disabled]="disabledRelatedTo">
              <option *ngFor="let contact of contactTypes" [value]="contact.key">{{contact.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Passenger form start -->
      <form [formGroup]="passengerForm" *ngIf="relatedTo === CONTACT_TYPES.PASSENGER">
        <div class="form-container ion-padding-horizontal toggle-visibility">

          <div class="row">
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">First Name*</label>
                <div
                  [ngClass]="{ 'invalid-input': passengerForm.get('firstName')?.invalid && passengerForm.get('firstName')?.touched }">
                  <input formControlName="firstName" type="text" class="input input-text"
                    placeholder="Customer's First Name" [appMaxLength]="50">
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Last Name</label>
                <div
                  [ngClass]="{ 'invalid-input': passengerForm.get('lastName')?.invalid && passengerForm.get('lastName')?.touched }">
                  <input formControlName="lastName" type="text" class="input input-text"
                    placeholder="Customer's Last Name" [appMaxLength]="50">
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Phone Number*</label>
                <div
                  [ngClass]="{ 'invalid-input': passengerForm.get('phone')?.invalid && passengerForm.get('phone')?.touched }">
                  <!-- <input type="number" formControlName="phone" placeholder="Ex- 9898989898" class="input"> -->
                  <app-phone-country-input formControlName="phone"></app-phone-country-input>
                </div>
              </div>
            </div>
          </div>

          <div class="row">


            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Email ID</label>
                <div
                  [ngClass]="{ 'invalid-input': passengerForm.get('email')?.invalid && passengerForm.get('email')?.touched }">
                  <input formControlName="email" type="text" class="input input-text" placeholder="Email address"
                    [appMaxLength]="64">
                </div>
              </div>
            </div>

            <div class="col-2">
              <div class="input-container">
                <label for="" class="label">DOB</label>
                <div
                  [ngClass]="{ 'invalid-input': passengerForm.get('dateOfBirth')?.invalid && passengerForm.get('dateOfBirth')?.touched }">
                  <app-date-picker formControlName="dateOfBirth" [maxDate]="today"></app-date-picker>
                </div>
              </div>
            </div>

            <div class="col-2">
              <div class="input-container">
                <label for="" class="label">Gender</label>
                <div
                  [ngClass]="{ 'invalid-input': passengerForm.get('gender')?.invalid && passengerForm.get('gender')?.touched }">
                  <select formControlName="gender" name="" class="input" id="">
                    <option value="" hidden>-- gender --</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                    <option value="Prefer not to say">Prefer not to say</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Customers Company Name</label>
                <div
                  [ngClass]="{ 'invalid-input': passengerForm.get('company')?.invalid && passengerForm.get('company')?.touched }">
                  <!-- <app-locations-autocomplete formControlName="company" [placeHolder]="'Ex- Deloitte'"></app-locations-autocomplete> -->
                  <input type="text" placeholder="Ex- Deloitte" formControlName="company" class="input"
                    [appMaxLength]="100">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-8">
              <div class="mt-2 mb-2 d-flex justify-content-between align-items-center">
                <div>
                  <ion-title class="dark-title-sm ion-no-padding">Customer's Documents</ion-title>
                </div>


                <div>
                  <ion-button id="upload-trigger" class="unfilled-blue-btn">Upload</ion-button>
                </div>
                <ion-popover class="upload-popover" trigger="upload-trigger" triggerAction="click" side="right"
                  alignment="start">
                  <ng-template>
                    <ion-content class="ion-padding">
                      <form #uploadForm="ngForm">
                        <div>
                          <div class="grid-container">
                            <div>
                              <select name="documentType" id="documentType" class="input-field" name="documentType"
                                [(ngModel)]="documentType" (change)="onDocumentTypeChange()" required>
                                <option value="" hidden>-- select document type --</option>
                                <option *ngFor="let docType of documentTypesArr" [value]="docType">{{docType}}</option>
                              </select>
                            </div>
                            <div>
                              <input class="input-field" type="text" placeholder="Enter Document Type"
                                name="otherDocumentType" [(ngModel)]="otherDocumentType"
                                *ngIf="documentType == 'Others'" required>
                            </div>
                            <div>
                              <input class="input-field" type="file" accept=".png, .jpg, .jpeg, .pdf"
                                (change)="onFileSelected($event)" required>
                            </div>
                            <div *ngIf="attachedFileName">
                              <p class="attached-doc clickable-file ms-1" (click)="openAttachedFile()">{{
                                attachedFileName }}</p>
                            </div>
                          </div>
                          <div class="buttons-container d-flex justify-content-end">
                            <button #documentResetBtn type="reset"></button>
                            <ion-button class="unfilled-gray-btn me-1" type="reset"
                              (click)="resetAttachemenForm()">Reset</ion-button>
                            <ion-button class="filled-blue-btn" [disabled]="!uploadForm.valid"
                              (click)="submitAttachmentForm()">Submit</ion-button>
                          </div>
                        </div>
                      </form>
                    </ion-content>
                  </ng-template>
                </ion-popover>


              </div>
            </div>
          </div>



          <div class="row">
            <div class="col-8">
              <div class="attachements-table-container">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th style="width: 40px;">S no</th>
                      <th style="width: 40%;">Document Name</th>
                      <th>Attachment</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container>
                      <tr *ngFor="let doc of documentsAttached.controls; index as i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ doc.get('documentCategory')?.value }}</td>
                        <td>
                          <span class="clickable-file" *ngIf="doc.get('file')?.value"
                            (click)="openFile(doc.get('file')?.value)">
                            {{ doc.get('file')?.value.name }}
                          </span>
                          <span class="clickable-file" *ngIf="!doc.get('file')?.value && doc.get('path')?.value"
                            (click)="openExistingFile(doc.get('path')?.value)">
                            {{ doc.get('fileName')?.value }}
                          </span>
                        </td>
                        <td class="py-0">
                          <ion-button (click)="removeDoucment(i)" class="delete-btn action-btn">
                            <ion-icon name="trash-outline"></ion-icon>
                          </ion-button>
                        </td>
                      </tr>

                      <tr *ngIf="documentsAttached.controls.length === 0">
                        <td colspan="4" class="text-center">No Documents Added</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- Passenger form end -->

      <!-- DMS form start -->
      <form [formGroup]="dmcForm" *ngIf="relatedTo === CONTACT_TYPES.DMC">
        <div class="form-container ion-padding-horizontal toggle-visibility">
          <div class="row">
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Organization Name*</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('organizationName')?.invalid && dmcForm.get('organizationName')?.touched }">
                  <input formControlName="organizationName" type="text" class="input input-text"
                    placeholder="Your Organization Name" [appMaxLength]="60">
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Contact's First Name*</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('firstName')?.invalid && dmcForm.get('firstName')?.touched }">
                  <input formControlName="firstName" type="text" class="input input-text" placeholder="First Name"
                    [appMaxLength]="50">
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Contact's Last Name</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('lastName')?.invalid && dmcForm.get('lastName')?.touched }">
                  <input formControlName="lastName" type="text" class="input input-text" placeholder="Last Name"
                    [appMaxLength]="50">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Phone Number *</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('primaryPhoneNumber')?.invalid && dmcForm.get('primaryPhoneNumber')?.touched }">
                  <app-phone-country-input formControlName="primaryPhoneNumber"></app-phone-country-input>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Additional Phone Number</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('secondaryPhoneNumber')?.invalid && dmcForm.get('secondaryPhoneNumber')?.touched }">
                  <app-phone-country-input formControlName="secondaryPhoneNumber"></app-phone-country-input>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Email Address*</label>
                <div [ngClass]="{ 'invalid-input': dmcForm.get('email')?.invalid && dmcForm.get('email')?.touched }">
                  <input formControlName="email" class="input input-text" placeholder="Email Address"
                    [appMaxLength]="64">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Serving Locations *</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('locations')?.invalid && dmcForm.get('locations')?.touched }">
                  <app-multi-select-locations formControlName="locations" [googleLocations]="true" [placeHolder]="'-- select locations --'"></app-multi-select-locations>
                </div>
                
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Website Link</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('websiteLink')?.invalid && dmcForm.get('websiteLink')?.touched }">
                  <input type="text" class="input" formControlName="websiteLink" placeholder="www.yourdomain.com"
                    [appMaxLength]="60">
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="input-container">
                <label for="" class="label">Preference</label>
                <div [ngClass]="{ 'invalid-input': dmcForm.get('rating')?.invalid && dmcForm.get('rating')?.touched }">
                  <select formControlName="rating" id="" class="input">
                    <option value="" hidden>--Preference--</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Address Lane 1 *</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('address1')?.invalid && dmcForm.get('address1')?.touched }">
                  <input formControlName="address1" type="text" class="input input-text" placeholder="Address"
                    [appMaxLength]="100">
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Address Lane 2 </label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('address2')?.invalid && dmcForm.get('address2')?.touched }">
                  <input formControlName="address2" type="text" class="input input-text" placeholder="Address 2"
                    [appMaxLength]="100">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">City</label>
                <div [ngClass]="{ 'invalid-input': dmcForm.get('city')?.invalid && dmcForm.get('city')?.touched }">
                  <input formControlName="city" type="text" class="input input-text" placeholder="Hyderabad"
                    [appMaxLength]="50">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">State</label>
                <div [ngClass]="{ 'invalid-input': dmcForm.get('state')?.invalid && dmcForm.get('state')?.touched }">
                  <input formControlName="state" type="text" class="input input-text" placeholder="Select State"
                    [appMaxLength]="50">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Zip Code</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('zipCode')?.invalid && dmcForm.get('zipCode')?.touched }">
                  <input formControlName="zipCode" type="text" class="input input-text" placeholder="500055"
                    [appMaxLength]="10">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Country</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('country')?.invalid && dmcForm.get('country')?.touched }">
                  <input formControlName="country" type="text" class="input input-text" placeholder="India"
                    [appMaxLength]="50">
                </div>
              </div>
            </div>
          </div>

          <!-- notes input -->
          <div class="row">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">Notes</label>
                <div [ngClass]="{ 'invalid-input': dmcForm.get('notes')?.invalid && dmcForm.get('notes')?.touched }">
                  <textarea name="" id="" class="input " formControlName="notes" placeholder="Notes here"></textarea>
                </div>
              </div>
            </div>
          </div>

        </div>
      </form>
      <!-- DMS form end -->

      <!-- Vendor form start -->
      <form [formGroup]="vendorForm" *ngIf="relatedTo === CONTACT_TYPES.VENDOR">
        <div class="form-container ion-padding-horizontal toggle-visibility">
          <div class="row">
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Organization Name*</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('organizationName')?.invalid && vendorForm.get('organizationName')?.touched }">
                  <input formControlName="organizationName" type="text" class="input input-text"
                    placeholder="Your Organization Name">
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Contact's First Name*</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('firstName')?.invalid && vendorForm.get('firstName')?.touched }">
                  <input formControlName="firstName" type="text" class="input input-text" placeholder="First Name">
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Contact's Last Name</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('lastName')?.invalid && vendorForm.get('lastName')?.touched }">
                  <input formControlName="lastName" type="text" class="input input-text" placeholder="First Name">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Phone Number *</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('primaryPhoneNumber')?.invalid && vendorForm.get('primaryPhoneNumber')?.touched }">
                  <app-phone-country-input formControlName="primaryPhoneNumber"></app-phone-country-input>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Additional Phone Number</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('secondaryPhoneNumber')?.invalid && vendorForm.get('secondaryPhoneNumber')?.touched }">
                  <app-phone-country-input formControlName="secondaryPhoneNumber"></app-phone-country-input>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Email Address*</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('email')?.invalid && vendorForm.get('email')?.touched }">
                  <input formControlName="email" class="input input-text" placeholder="Email Address">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Service Types *</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('serviceTypes')?.invalid && vendorForm.get('serviceTypes')?.touched }">
                  <app-multi-select-dropdown [dropdownItems]="vendorServices"
                    formControlName="serviceTypes"></app-multi-select-dropdown>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Website Link</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('websiteLink')?.invalid && vendorForm.get('websiteLink')?.touched }">
                  <input type="text" class="input" formControlName="websiteLink" placeholder="www.yourdomain.com">
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="input-container">
                <label for="" class="label">Preference</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('rating')?.invalid && vendorForm.get('rating')?.touched }">
                  <select formControlName="rating" id="" class="input">
                    <option value="" hidden>--Preference--</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Address Lane 1 *</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('address1')?.invalid && vendorForm.get('address1')?.touched }">
                  <input formControlName="address1" type="text" class="input input-text" placeholder="Address">
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Address Lane 2 </label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('address2')?.invalid && vendorForm.get('address2')?.touched }">
                  <input formControlName="address2" type="text" class="input input-text" placeholder="Address 2">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">City</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('city')?.invalid && vendorForm.get('city')?.touched }">
                  <input formControlName="city" type="text" class="input input-text" placeholder="Hyderabad">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">State</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('state')?.invalid && vendorForm.get('state')?.touched }">
                  <input formControlName="state" type="text" class="input input-text" placeholder="Select State">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Zip Code</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('zipCode')?.invalid && vendorForm.get('zipCode')?.touched }">
                  <input formControlName="zipCode" type="text" class="input input-text" placeholder="500055">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Country</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('country')?.invalid && vendorForm.get('country')?.touched }">
                  <input formControlName="country" type="text" class="input input-text" placeholder="India">
                </div>
              </div>
            </div>
          </div>

          <!-- notes input -->
          <div class="row">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">Notes</label>
                <div
                  [ngClass]="{ 'invalid-input': vendorForm.get('notes')?.invalid && vendorForm.get('notes')?.touched }">
                  <textarea name="" id="" class="input " formControlName="notes" placeholder="Notes here"></textarea>
                </div>
              </div>
            </div>
          </div>

        </div>
      </form>
      <!-- Vendor form end -->

      <!-- Agent form start -->
      <form [formGroup]="agentForm" *ngIf="relatedTo === CONTACT_TYPES.AGENT">
        <div class="form-container ion-padding-horizontal toggle-visibility">
          <div class="row">
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Organization Name*</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('organizationName')?.invalid && agentForm.get('organizationName')?.touched }">
                  <input formControlName="organizationName" type="text" class="input input-text"
                    placeholder="Your Organization Name">
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Contact's First Name*</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('firstName')?.invalid && agentForm.get('firstName')?.touched }">
                  <input formControlName="firstName" type="text" class="input input-text" placeholder="First Name">
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Contact's Last Name</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('lastName')?.invalid && agentForm.get('lastName')?.touched }">
                  <input formControlName="lastName" type="text" class="input input-text" placeholder="First Name">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Phone Number *</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('primaryPhoneNumber')?.invalid && agentForm.get('primaryPhoneNumber')?.touched }">
                  <app-phone-country-input formControlName="primaryPhoneNumber"></app-phone-country-input>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Additional Phone Number</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('secondaryPhoneNumber')?.invalid && agentForm.get('secondaryPhoneNumber')?.touched }">
                  <app-phone-country-input formControlName="secondaryPhoneNumber"></app-phone-country-input>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Email Address*</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('email')?.invalid && agentForm.get('email')?.touched }">
                  <input formControlName="email" class="input input-text" placeholder="Email Address">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Serving Locations *</label>
                <div
                  [ngClass]="{ 'invalid-input': dmcForm.get('locations')?.invalid && dmcForm.get('locations')?.touched }">
                  <app-multi-select-locations formControlName="locations" [googleLocations]="true" [placeHolder]="'-- select locations --'"></app-multi-select-locations>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Website Link</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('websiteLink')?.invalid && agentForm.get('websiteLink')?.touched }">
                  <input type="text" class="input" formControlName="websiteLink" placeholder="www.yourdomain.com">
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="input-container">
                <label for="" class="label">Preference</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('rating')?.invalid && agentForm.get('rating')?.touched }">
                  <select formControlName="rating" id="" class="input">
                    <option value="" hidden>--Preference--</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Address Lane 1 *</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('address1')?.invalid && agentForm.get('address1')?.touched }">
                  <input formControlName="address1" type="text" class="input input-text" placeholder="Address">
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Address Lane 2 </label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('address2')?.invalid && agentForm.get('address2')?.touched }">
                  <input formControlName="address2" type="text" class="input input-text" placeholder="Address 2">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">City</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('city')?.invalid && agentForm.get('city')?.touched }">
                  <input formControlName="city" type="text" class="input input-text" placeholder="Hyderabad">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">State</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('state')?.invalid && agentForm.get('state')?.touched }">
                  <input formControlName="state" type="text" class="input input-text" placeholder="Select State">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Zip Code</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('zipCode')?.invalid && agentForm.get('zipCode')?.touched }">
                  <input formControlName="zipCode" type="text" class="input input-text" placeholder="500055">
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Country</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('country')?.invalid && agentForm.get('country')?.touched }">
                  <input formControlName="country" type="text" class="input input-text" placeholder="India">
                </div>
              </div>
            </div>
          </div>

          <!-- notes input -->
          <div class="row">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">Notes</label>
                <div
                  [ngClass]="{ 'invalid-input': agentForm.get('notes')?.invalid && agentForm.get('notes')?.touched }">
                  <textarea name="" id="" class="input " formControlName="notes" placeholder="Notes here"></textarea>
                </div>
              </div>
            </div>
          </div>

        </div>
      </form>
      <!-- agent form end -->


    </div>
  </div>
</ion-content>